<template lang="pug">
  div
    transition(name="slide-up" appear)
      .claim-selection-actions(v-if="show")
        .actions-container
          .selection-info
            .yz-regular-body-sm {{ selectedItems.length }} {{ $t('panel.items') }} {{ $t('panel.selected').toLowerCase() }}
          .actions-group
            yz-tooltip(:text="downloadTooltipText" :disabled="!isDownloadDisabled")
              yz-btn(:label="$t('panel.download_panel_claim')" size="lg" :disabled="isDownloadDisabled" :loading="isDownloading" @click="onDownloadPanelClaim")
            yz-menu(v-if="activeTab !== 0 && activeTab !== 6" v-model="menuOpen" offset-y top nudge-top="4")
              template(v-slot:activator="{ on, attrs }")
                yz-btn(:label="$t('panel.update_claim_status')" size="lg" :append-icon="menuOpen ? '$yzi-chevron-up' : '$yzi-chevron-down'" v-bind="attrs" v-on="on")
              yz-list
                template(v-if="activeTab !== 4")
                  yz-list-item(@click="onMarkAsApproved")
                    div {{ $t('panel.mark_all_as_approved') }}
                  template(v-if="activeTab !== 5")
                    yz-divider
                template(v-if="activeTab !== 5")
                  yz-list-item(@click="onMarkAsRejected")
                    div {{ $t('panel.mark_all_as_rejected') }}
                  yz-divider(v-if="activeTab === 3 || activeTab === 4")
                template(v-if="activeTab !== 5")
                  yz-list-item(@click="onMarkAsReceived")
                    div {{ $t('panel.mark_all_as_received') }}

    bulk-update-approve-dialog(v-if="showApproveDialog" v-model="showApproveDialog" :selected-items="selectedItems" @confirmed="onApproveConfirmed" @canceled="onApproveCanceled" @close="onApproveCanceled")
    bulk-update-reject-dialog(v-if="showRejectDialog" v-model="showRejectDialog" :selected-items="selectedItems" @confirmed="onRejectConfirmed" @canceled="onRejectCanceled" @close="onRejectCanceled")
    bulk-update-submitted-to-received-dialog(v-if="showSubmittedToReceivedDialog" v-model="showSubmittedToReceivedDialog" :selected-items="selectedItems" @confirmed="onReceivedConfirmed" @canceled="onReceivedCanceled" @close="onReceivedCanceled")
    bulk-update-approved-to-received-dialog(v-if="showApprovedToReceivedDialog" v-model="showApprovedToReceivedDialog" :selected-items="selectedItems" @confirmed="onReceivedConfirmed" @canceled="onReceivedCanceled" @close="onReceivedCanceled")
</template>

<script>
import BulkUpdateApproveDialog from '@/components/clinic/panel/dialogs/bulk/BulkUpdateApproveDialog.vue'
import BulkUpdateRejectDialog from '@/components/clinic/panel/dialogs/bulk/BulkUpdateRejectDialog.vue'
import BulkUpdateSubmittedToReceivedDialog from '@/components/clinic/panel/dialogs/bulk/BulkUpdateSubmittedToReceivedDialog.vue'
import BulkUpdateApprovedToReceivedDialog from '@/components/clinic/panel/dialogs/bulk/BulkUpdateApprovedToReceivedDialog.vue'

export default {
  components: { BulkUpdateApproveDialog, BulkUpdateRejectDialog, BulkUpdateSubmittedToReceivedDialog, BulkUpdateApprovedToReceivedDialog },
  props: {
    selectedItems: {
      type: Array,
      default: () => []
    },
    activeTab: {
      type: Number,
      default: 0
    },
    show: {
      type: Boolean,
      default: false
    },
    isDownloading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      downloadLimit: 20,
      menuOpen: false,
      showApproveDialog: false,
      showRejectDialog: false,
      showSubmittedToReceivedDialog: false,
      showApprovedToReceivedDialog: false
    }
  },
  computed: {
    isDownloadDisabled() {
      return this.selectedItems.length > this.downloadLimit
    },
    downloadTooltipText() {
      if (this.selectedItems.length > this.downloadLimit) {
        return this.$t('panel.download_limit_exceeded')
      }
      return ''
    }
  },
  methods: {
    onDownloadPanelClaim() {
      this.$emit('download-panel-claim', this.selectedItems)
    },
    onMarkAsApproved() {
      this.showApproveDialog = true
      this.menuOpen = false
    },
    onMarkAsRejected() {
      this.showRejectDialog = true
      this.menuOpen = false
    },
    onMarkAsReceived() {
      // activeTab: 3 = Submitted, 4 = Approved
      if (this.activeTab === 3) {
        // Submitted -> Received: Full editing capabilities
        this.showSubmittedToReceivedDialog = true
      } else if (this.activeTab === 4) {
        // Approved -> Received: Limited editing
        this.showApprovedToReceivedDialog = true
      }
      this.menuOpen = false
    },
    onApproveConfirmed() {
      this.$emit('updated')
      this.showApproveDialog = false
    },
    onApproveCanceled() {
      this.showApproveDialog = false
    },
    onRejectConfirmed() {
      this.$emit('updated')
      this.showRejectDialog = false
    },
    onRejectCanceled() {
      this.showRejectDialog = false
    },
    onReceivedConfirmed() {
      this.$emit('updated')
      this.showSubmittedToReceivedDialog = false
      this.showApprovedToReceivedDialog = false
    },
    onReceivedCanceled() {
      this.showSubmittedToReceivedDialog = false
      this.showApprovedToReceivedDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.claim-selection-actions {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  background-color: white;
  padding: 12px 16px;
  box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.2);
  z-index: 100;
  border-radius: 10px;
  max-width: 700px;
  margin: 0 auto;
  border-bottom: 3px solid #000000;
}

.actions-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.actions-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

// Transition animations
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-enter-to,
.slide-up-leave {
  transform: translateY(0);
  opacity: 1;
}

// Responsive design
@media (max-width: 768px) {
  .claim-selection-actions {
    padding: 12px 16px;
  }

  .actions-container {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .selection-info {
    text-align: center;
  }

  .actions-group {
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .actions-group {
    flex-direction: column;
    gap: 8px;
  }
}
</style>